import { browserHistory } from 'react-router';
import { routerMiddleware } from 'react-router-redux';
import thunkMiddleware from 'redux-thunk';

import { fullstoryMiddleware } from '../../middleware/fullstory';
import { analyticsLogger } from '../../middleware/google-analytics';
import { pageCategoryMiddleware } from '../../middleware/pageCategory';
import { branchTrackerMiddleware } from '../../middleware/branch-middleware';

export default pageName => {
    return [
        thunkMiddleware,
        pageCategoryMiddleware(pageName),
        analyticsLogger,
        routerMiddleware(browserHistory),
        branchTrackerMiddleware,
        fullstoryMiddleware,
    ];
};
